export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewPermission(state, { payload }) {
    state.permissions = [...state.permissions, ...[payload]];
  },

  delProperty(state, { property }) {
    state.permissions = state.permissions.filter(el => el.id !== property);
  },
};
